import { CheckerboardRemoveIcon } from './CheckerboardRemoveIcon';

/**
 * author: Michael Irigoyen
 * id CDCAA6DE-0885-474F-992F-6A7F46563A15
 * name checkerboard-remove
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkerboard-remove.svg
 * tags
 * - Geographic Information System 
 */
export const RasterRemoveIcon = CheckerboardRemoveIcon;
export default RasterRemoveIcon